/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgBadgeAlt6S = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M11.113 12.05c-.206-.233-.31-.557-.31-.97 0-.18.014-.357.04-.53.274-.507.684-.76 1.23-.76.327 0 .587.117.78.35.194.227.29.533.29.92 0 .413-.106.74-.32.98-.206.24-.49.36-.85.36-.366 0-.653-.117-.86-.35z" />
        <path d="M11.305.281a1 1 0 0 1 1.39 0l1.874 1.813 2.581-.365a1 1 0 0 1 1.125.817l.45 2.568 2.303 1.221a1 1 0 0 1 .43 1.323L20.313 10l1.145 2.342a1 1 0 0 1-.43 1.323l-2.303 1.221-.45 2.568a1 1 0 0 1-1.125.817l-2.581-.365-1.874 1.813a1 1 0 0 1-1.39 0L9.43 17.906l-2.581.365a1 1 0 0 1-1.125-.817l-.45-2.568-2.303-1.222a1 1 0 0 1-.43-1.322L3.687 10 2.542 7.658a1 1 0 0 1 .43-1.323l2.303-1.221.45-2.568A1 1 0 0 1 6.85 1.73l2.581.365zm2.988 12.129c.22-.393.33-.853.33-1.38 0-.733-.196-1.313-.59-1.74-.393-.427-.93-.64-1.61-.64-.326 0-.623.073-.89.22.14-.227.307-.477.5-.75l1.3-1.79h-1.66l-1.18 1.63a7.018 7.018 0 0 0-.87 1.56c-.2.527-.3 1.017-.3 1.47 0 .827.234 1.473.7 1.94.474.467 1.124.7 1.95.7.54 0 1.007-.107 1.4-.32.4-.213.707-.513.92-.9z" />
        <path d="m10.61 20.438-1.523-1.473L8 19.119v4.88l4-1.5 4 1.5v-4.88l-1.087-.154-1.522 1.473a2 2 0 0 1-2.782 0z" />
      </g>
    </g>
  </Icon>
);
export { SvgBadgeAlt6S as BadgeAlt6S };
